import { useContext, useState } from 'react';
import { useOnChange } from '../../../../helpers/hooks/useOnChange';
import { assertNotNull } from '../../../../helpers/nullHelpers';
import { SelectField } from '../../../../shared/form/inputs/SelectField';
import { cylinderSizingLookupsByHeatPumpUnitName } from '../heat-pump/cylinderSizingLookups';
import { unitFieldName } from '../quoteOrDesignFormFieldNameHelpers';
import { cylinderVolumeSelectOptions, cylinderVolumeSelectOptionsWithLimits } from './cylinderVolumes';
import { UnitFieldContext } from './UnitFieldContext';

export const CylinderVolumeField = () => {
  const { unit, unitIndex } = assertNotNull(useContext(UnitFieldContext));
  const [cylinderVolumeOptions, setCylinderVolumeOptions] = useState(cylinderVolumeSelectOptions);

  useOnChange(() => {
    const heatPumpUnitName = unit.heatPump?.heatPumpUnitParts[0]?.displayName;

    if (!heatPumpUnitName || unit.heatPump?.heatPumpUnitParts.length !== 1) {
      setCylinderVolumeOptions(cylinderVolumeSelectOptions);
      return;
    }

    const cylinderSizingLimitLookupForHeatPumpUnit = cylinderSizingLookupsByHeatPumpUnitName[heatPumpUnitName];
    if (cylinderSizingLimitLookupForHeatPumpUnit == null) {
      setCylinderVolumeOptions(cylinderVolumeSelectOptions);
      return;
    }

    const newOptions = cylinderVolumeSelectOptionsWithLimits(
      cylinderSizingLimitLookupForHeatPumpUnit,
      unit.solar == null,
    );

    setCylinderVolumeOptions(newOptions);
    return;
  }, [unit.heatPump?.heatPumpUnitParts?.map(part => part?.partId).join(','), unit.solar]);

  return (
    <SelectField<string | null>
      name={unitFieldName(unitIndex, 'cylinderVolumeOption')}
      label="Cylinder Vol. (l)"
      options={cylinderVolumeOptions}
    />
  );
};
